module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "chap",
    attrs: {
      "id": "acknow"
    }
  }, [_c('p', {
    staticClass: "ct"
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/OEBPS/pppjusticedamned0006#toc"
    }
  }, [_vm._v("Acknowledgments")])]), _vm._v(" "), _c('p', {
    staticClass: "pf"
  }, [_vm._v("Christine and Peter Goodhugh, Ed Kaufman of M Is for Mystery in San Mateo, CA, Henie Lentz, Dianne Levy, Sharon Kay Penman, Barbara Peters of Poisoned Pen Bookstore in Scottsdale, AZ, Robert Rosenwald and all the staff at Poisoned Pen Press, Marianne and Sharon Silva, Sisters in Crime, Lyn and Michael Speakman, and the staff at University Press Bookstore in Berkeley, CA.")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-62ed1c60","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/OEBPS/ppp-justicedamned0007.vue
// module id = 75
// module chunks = 0